import { Form } from "antd";

import { useTranslation } from "src/translations";
import { Checkbox } from "../../../Form/formComponents";
import { HorizontalFormFieldStyle } from "../../../Form/formFieldLabelPositioning/styles/Styles";
import type { FieldMethod, FormFieldFactoryProps } from "../../../Form/types/types";

export const EditableListCheckBoxField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const { t } = useTranslation();

    return (
        <HorizontalFormFieldStyle key={`${field.name}FormControl `}>
            <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules} label={t(field.translationKeys.label)}>
                <Checkbox key={field.name} name={field.name} readOnly={readOnly} label={" "} />
            </Form.Item>
        </HorizontalFormFieldStyle>
    );
};
